var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import EmojiPicker, { Theme } from 'emoji-picker-react';
import { store, useAppSelector } from '../../store';
import TextBoxArea from './text-box';
import ChatTabs from './chatTabs';
const isChatLockSelector = createSelector(_react_refresh_temp_1 = (state) => { var _a, _b; return (_b = (_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lock_settings; }, (lock_settings) => lock_settings === null || lock_settings === void 0 ? void 0 : lock_settings.lock_chat);
$RefreshReg$(_react_refresh_temp_1, "isChatLockSelector$createSelector");
const themeSelector = createSelector(_react_refresh_temp_2 = (state) => state.roomSettings, (roomSettings) => roomSettings.theme);
$RefreshReg$(_react_refresh_temp_2, "themeSelector$createSelector");
const ChatComponent = ({ currentRoom, isRecorder }) => {
    _react_refresh_temp_4();
    const isChatLock = useAppSelector(isChatLockSelector);
    const theme = useAppSelector(themeSelector);
    const [show, setShow] = useState(false);
    const [chosenEmoji, setChosenEmoji] = useState(null);
    const [isOpenEmojiPanel, setIsOpenEmojiPanel] = useState(false);
    // default room lock settings
    useEffect(() => {
        var _a, _b, _c, _d;
        const isLock = (_b = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.default_lock_settings) === null || _b === void 0 ? void 0 : _b.lock_chat;
        const isAdmin = (_d = (_c = store.getState().session.currentUser) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.is_admin;
        if (isLock && !isAdmin) {
            if (isChatLock !== false) {
                setShow(false);
            }
        }
    }, []);
    useEffect(() => {
        if (isRecorder) {
            setShow(false);
        }
    }, [isRecorder]);
    useEffect(() => {
        if (isRecorder) {
            return;
        }
        if (isChatLock) {
            setShow(false);
        }
        else {
            setShow(true);
        }
    }, [isChatLock, isRecorder]);
    const onEmojiClick = (data) => {
        setChosenEmoji(`${data.emoji}`);
    };
    const onAfterSendMessage = () => {
        if (isOpenEmojiPanel) {
            setIsOpenEmojiPanel(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "h-[calc(100%)] messageModule-wrapper relative z-10 right-0 top-0 w-[250px] xl:w-[320px] multi-gradient", children: _jsx("div", { className: "all-MessageModule-wrap h-full", children: _jsx(ChatTabs, {}) }) }), isRecorder ? (_jsx("div", { className: "w-[100%] h-[1px] hiddenAnimation absolute z-50 bottom-0 bg-gradient-to-r from-primaryColor to-secondaryColor" })) : null, show ? (_jsxs(_Fragment, { children: [_jsx("div", { className: `emoji-selection-wrap w-[250px] xl:w-[300px] fixed z-[99] bottom-[120px] lg:bottom-[65px] right-0 left-10 md:left-auto transition ease-in ${isOpenEmojiPanel
                            ? 'emoji-active opacity-100 visible pointer-events-auto'
                            : 'opacity-0 invisible pointer-events-none'}`, children: isOpenEmojiPanel ? (_jsx(EmojiPicker, { onEmojiClick: onEmojiClick, lazyLoadEmojis: true, theme: theme === 'dark' ? Theme.DARK : Theme.LIGHT })) : null }), _jsxs("div", { className: "message-form fixed z-[99] xl:z-0 bottom-1 w-[250px] xl:w-[320px] bg-white", children: [_jsx(TextBoxArea, { currentRoom: currentRoom, chosenEmoji: chosenEmoji, onAfterSendMessage: onAfterSendMessage }), _jsx("div", { className: `emoji-picker absolute left-2 md:-left-6 bottom-5 w-5 h-5 cursor-pointer text-secondaryColor dark:text-darkText ${isOpenEmojiPanel ? 'emoji-active' : ''}`, onClick: () => setIsOpenEmojiPanel(!isOpenEmojiPanel), children: isOpenEmojiPanel ? (_jsx("i", { className: "pnm-cross" })) : (_jsx("i", { className: "pnm-emoji" })) })] })] })) : null] }));
};
_react_refresh_temp_3 = ChatComponent;
$RefreshReg$(_react_refresh_temp_3, "ChatComponent");
_react_refresh_temp_4(ChatComponent, "OihzJcgbFCvhMRp4FL19oFtXjTs=", false, () => [useAppSelector, useAppSelector]);
export default ChatComponent;
